import React from "react";
import CountryLayout from "@/components/CountryLayout";

export default function CountryUK() {
  return <CountryLayout countryKey="united-kingdom" countryCode="uk" sourcePage="/countries/united-kingdom" />;
}
